import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../../styles/auth/ResendVerification.css';

const ResendVerification = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setSending(true);

    const form = e.target;
    try {
      const submitData = {
        email: email.trim(),
        website: form.website?.value ?? '',
        email_confirm: form.email_confirm?.value ?? '',
        _submission_time: Date.now().toString(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/resend-verification`,
        submitData,
        { withCredentials: true }
      );

      if (response.data.success) {
        setMessage(response.data.message || 'Ny verifiseringslenke er sendt til din e-post.');
        setEmail('');
      } else {
        setError(response.data.message || 'Kunne ikke sende ny verifiseringslenke.');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Kunne ikke sende. Prøv igjen senere.';
      setError(msg);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="resend-verification-container">
      <div className="resend-verification-card">
        <h1>Send ny verifiseringslenke</h1>
        <p className="resend-verification-intro">
          Verifiseringslenken i e-posten utløper etter 24 timer. Skriv inn e-postadressen din under, så sender vi en ny lenke.
        </p>

        <form onSubmit={handleSubmit} className="resend-verification-form">
          {message && <div className="resend-success-message">{message}</div>}
          {error && <div className="resend-error-message">{error}</div>}

          <label htmlFor="resend-email" className="resend-label">E-postadresse</label>
          <input
            id="resend-email"
            type="email"
            name="email"
            placeholder="din@epost.no"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            className="resend-input"
            disabled={sending}
          />

          {/* Honeypot: hidden from users; bots that fill these get a fake success */}
          <div className="resend-honeypot" aria-hidden="true">
            <input
              type="text"
              name="website"
              tabIndex={-1}
              autoComplete="off"
              defaultValue=""
              className="resend-honeypot-input"
            />
            <input
              type="text"
              name="email_confirm"
              tabIndex={-1}
              autoComplete="off"
              defaultValue=""
              className="resend-honeypot-input"
            />
          </div>

          <button type="submit" className="resend-submit" disabled={sending}>
            {sending ? 'Sender...' : 'Send ny verifiseringslenke'}
          </button>
        </form>

        <div className="resend-verification-links">
          <Link to="/login" className="resend-link">Tilbake til innlogging</Link>
          <Link to="/verify-email" className="resend-link">Har du allerede en lenke?</Link>
        </div>
      </div>
    </div>
  );
};

export default ResendVerification;
